import { useState, useEffect } from "react";
import CONSTANTS from "../../../Constants/Constants";
import ENVIRONMENT from "../../../Constants/Environment";
import { has_data_provider } from "../../../helpers/general";
import { fetchAgentPriceMarkupInfo } from "../../../services/agentServices";

//Offer item cards
import OfferItem from "./FlightOfferCards/OfferItem";
import Type2OfferItem from "./FlightOfferCards/Type2OfferItem";
import Type3OfferItem from "./FlightOfferCards/Type3OfferItem";
import Type4OfferItem from "./FlightOfferCards/Type4OfferItem";
import Type5OfferItem from "./FlightOfferCards/Type5OfferItem";

const FlightOfferItem = (props) => {
    const {
        data_provider,
        bookingEngine,
        hasNewMessageFromParent,
        currentParentMessge,
        rawData,
    } = props;

    const [ PriceMarkupValue, setPriceMarkupValue ] = useState({
            type: "",
            value: 0,
        });
        const [ canShowPrice, setCanShowPrice ] = useState({
            profit_type: "",
            with_price_bound_profit: false,
            show: false,
        });
    
        useEffect(()=>{
            (async()=>{
                let _pm_obj = {
                    type: "",
                    value: 0,
                }
                let _can_show_obj = {
                    profit_type: "",
                    with_price_bound_profit: false,
                    show: false,
                }
                setCanShowPrice(_can_show_obj);
                setPriceMarkupValue(_pm_obj);
                if(
                    hasNewMessageFromParent &&
                    currentParentMessge?.from_welldugo_oc &&
                    currentParentMessge?.type==="engine-parameters"
                ){
                    if(currentParentMessge?.postBody?.apply_price_bound_profile){
                        _pm_obj.type = currentParentMessge?.postBody?.current_price_bound_profit_type;
                        _pm_obj.value = currentParentMessge?.postBody?.current_price_bound_profit_value;
                        _can_show_obj.with_price_bound_profit = true;
                        _can_show_obj.show = true;
                    }else{
                        _can_show_obj.with_price_bound_profit = false;
                        _can_show_obj.show = true;
                    }
                    //currentParentMessge?.postBody?.current_price_bound_supplier: "duffel",
                }else if(localStorage.getItem("engine_parameters")){
                    const engine_parameters = JSON.parse(localStorage.getItem("engine_parameters"));
                    if(engine_parameters?.postBody?.apply_price_bound_profile){
                        _pm_obj.type = engine_parameters?.postBody?.current_price_bound_profit_type;
                        _pm_obj.value = engine_parameters?.postBody?.current_price_bound_profit_value;
                        _can_show_obj.with_price_bound_profit = true;
                        _can_show_obj.show = true;
                        console.log(engine_parameters);
                    }else{
                        _can_show_obj.with_price_bound_profit = false;
                        _can_show_obj.show = true;
                    }
                }else {
                    if(localStorage.getItem("agent")){
                        const agent_id = localStorage.getItem("agent");
                        if(agent_id || agent_id!=="undefined"){
                            let _pm_res = await fetchAgentPriceMarkupInfo(agent_id);
                            _pm_obj.type = _pm_res?.type;
                            _pm_obj.value = _pm_res?.value;
                            _can_show_obj.with_price_bound_profit = true;
                            _can_show_obj.show = true;
                        }
                    }
                }
    
                // Update State Here
                setPriceMarkupValue({
                    type: _pm_obj?.type,
                    value: parseFloat(_pm_obj?.value),
                });
                setCanShowPrice({
                    ...canShowPrice,
                    with_price_bound_profit: _can_show_obj?.with_price_bound_profit,
                    show: _can_show_obj?.show,
                });
            })();
        }, [currentParentMessge]);

    const resultsCardType = parseInt((bookingEngine.searchResultsFlightCard || 1));
    
    if(has_data_provider(data_provider)) {
        return <>
            {
                (resultsCardType === 1) &&
                <OfferItem
                    PriceMarkupValue={PriceMarkupValue}
                    canShowPrice={canShowPrice}
                    bookingEngine={bookingEngine}
                    selectFlightOffer={props.selectFlightOffer}
                    flight={props.flight} 
                    index={props.index}
                    hasNewMessageFromParent={hasNewMessageFromParent}
                    currentParentMessge={currentParentMessge}
                    rawData={rawData}
                    data_provider={data_provider}
                />
            }
            {
                (resultsCardType === 2) &&
                <Type2OfferItem 
                    PriceMarkupValue={PriceMarkupValue}
                    canShowPrice={canShowPrice}
                    bookingEngine={bookingEngine}
                    selectFlightOffer={props.selectFlightOffer}
                    flight={props.flight} 
                    index={props.index}
                    hasNewMessageFromParent={hasNewMessageFromParent}
                    currentParentMessge={currentParentMessge}
                    rawData={rawData}
                    data_provider={data_provider}
                />
            }
            {
                (resultsCardType === 3) &&
                <Type3OfferItem 
                    PriceMarkupValue={PriceMarkupValue}
                    canShowPrice={canShowPrice}
                    bookingEngine={bookingEngine}
                    selectFlightOffer={props.selectFlightOffer}
                    flight={props.flight} 
                    index={props.index}
                    hasNewMessageFromParent={hasNewMessageFromParent}
                    currentParentMessge={currentParentMessge}
                    rawData={rawData}
                    data_provider={data_provider}
                />
            }
            {
                (resultsCardType === 4) &&
                <Type4OfferItem 
                    PriceMarkupValue={PriceMarkupValue}
                    canShowPrice={canShowPrice}
                    bookingEngine={bookingEngine}
                    selectFlightOffer={props.selectFlightOffer}
                    flight={props.flight} 
                    index={props.index}
                    hasNewMessageFromParent={hasNewMessageFromParent}
                    currentParentMessge={currentParentMessge}
                    rawData={rawData}
                    data_provider={data_provider}
                />
            }
            {
                (resultsCardType === 5) &&
                <Type5OfferItem 
                    PriceMarkupValue={PriceMarkupValue}
                    canShowPrice={canShowPrice}
                    bookingEngine={bookingEngine}
                    selectFlightOffer={props.selectFlightOffer}
                    flight={props.flight} 
                    index={props.index}
                    hasNewMessageFromParent={hasNewMessageFromParent}
                    currentParentMessge={currentParentMessge}
                    rawData={rawData}
                    data_provider={data_provider}
                />
            }
        </>
    } else {
        return <div style={{marginTop: 10, padding: 20, backgroundColor: "crimson", border: "2px dashed red", fontSize: 13}}>
            <p style={{fontSize: 13, color: "white"}}>
                <i style={{marginRight: 10, color: "yellow"}}
                    className="fa-solid fa-exclamation-triangle"></i>
                Data Source Not Identified.
            </p>
        </div>
    }
}

export default FlightOfferItem;